import { ElevarDataLayerEvent } from '@qlevr/shared/interfaces';
import { isBrowser } from '../is-browser';
import { elevarTrack } from './initialise-elevar';

export function analyticsTrackEvent(props: ElevarDataLayerEvent): void | null {
  if (!isBrowser()) return null;

  elevarTrack(props);
}
